import { makeStyles } from '@material-ui/core';

type Props = {
  borderColour?: string;
};

const useStyles = makeStyles((theme) => ({
  tableWrapper: {
    '& tr:nth-last-child(2):not(.expanded) td:first-child': {
      borderBottomLeftRadius: 0,
    },
    '& tr:nth-last-child(2):not(.expanded) td:last-child': {
      borderBottomRightRadius: 0,
    },
  },
  tableFooterWrapper: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingTop: theme.spacing(0.5),
    columnGap: theme.spacing(2),
  },
  tableTitle: {
    marginBottom: theme.spacing(2),
  },
  card: (props: Props) => ({
    maxHeight: '100%',
    ...(props.borderColour && {
      borderLeft: `${theme.spacing(1)} solid ${props.borderColour}`,
    }),
  }),
  header: {
    fontWeight: 'bold',
  },
}));

export default useStyles;
